import Timeline from './Timeline';
import TimelineItem from './TimelineItem';

Timeline.Item = TimelineItem;
export default Timeline;



// WEBPACK FOOTER //
// ./_antd1.11.2/timeline/index.jsx